import properties from '../../modules/ajio-util/properties';
import { SPIN_THE_WHEEL, SCRATCHCARD } from './gameRouteEntries';

const parentUrl = `${properties.getProperty('parentUrl')}`;
const imageBasePath = `${properties.getProperty('imageBaseUrl')}/static/img/`;
const audioBasePath = `${properties.getProperty('imageBaseUrl')}/static/audios/`;

// icons
export const CLOSE_ICON = `${imageBasePath}stw-mn-cls-icn.svg`;
export const RULES_ICON = `${imageBasePath}stw-mn-ruls-icn.svg`;
export const MYREWARDS_ICON = `${imageBasePath}stw-mn-myrds-icn.svg`;
export const AJIO_POINT_ICON = `${imageBasePath}stw-ajio-ptns-icn.png`;
export const COUPON_ICON = `${imageBasePath}stw-coupon-icn.svg`;
export const MODAL_CIRCLE_CLOSE_ICON = `${imageBasePath}stw-modal-close-icn.svg`;
export const CIRCLE_BLACK_CLOSE_ICON = `${imageBasePath}gm-crl-black-close-icn.svg`;
export const PRIZE_ICON = `${imageBasePath}stw-prize-icn.svg`;
export const SHARE_THEME_ICON = `${imageBasePath}stw-share-thm-icn.svg`;
export const CHECK_GREEN_ICON = `${imageBasePath}stw-check-grn-icn.svg`;
export const GENIE_ICON = `${imageBasePath}stw-genie-icn.svg`;
export const GIFT_ICON = `${imageBasePath}stw-gift-icn.svg`;
export const TIMER_ICON = `${imageBasePath}stw-timer-icn.png`;
export const SPEAKER_ACTIVE_ICON = `${imageBasePath}stw-spkr-icn.svg`;
export const SPEAKER_INACTIVE_ICON = `${imageBasePath}stw-spkr-mute-icn.svg`;
export const TROPHY_ICN_GRAY_BCKRD = `${imageBasePath}gm-gry-crl-trophy.svg`;
export const AJIO_CASH_ICON = `${imageBasePath}gm-ajio-cash.svg`;
export const AJIO_POINTS_ICON = `${imageBasePath}stw-ajio-ptns-icn.png`;
export const NO_OFFER_ICON = `${imageBasePath}stw-dartboard.svg`;
export const WRONG_CRICLE_ICON = `${imageBasePath}gm-rd-crl-wrong.svg`;
export const SCRATCH_ICON = `${imageBasePath}gm-scratch-icn.svg`;
export const SCRATCH_BACK_ICON = `${imageBasePath}gm-scratch-bck-icn.svg`;
export const DESK_MODAL_CLOSE_ICON = `${imageBasePath}gm-desk-modal-close-icn.svg`;
export const RC_BG_TROPHY_ICON = `${imageBasePath}gm-rc-bg-trophy.svg`;
export const SC_BG_AJIO_CASH_ICON = `${imageBasePath}scratch-bc-ajio-cash.svg`;
export const SC_BG_AJIO_POINTS_ICON = `${imageBasePath}scratch-bc-ajio-points.svg`;
export const SC_BG_BETTER_LUCK_ICON = `${imageBasePath}scratch-bc-better-luck.svg`;

// audios
export const SPIN_STOP_MUSIC_FILE = `${audioBasePath}spin-stop.mp3`;
export const SUCCESS_MUSIC_FILE = `${audioBasePath}success.mp3`;
export const BACKGROUND_MUSIC_FILE = `${audioBasePath}bgmusic.mp3`;
export const BUTTON_TAP_MUSIC_FILE = `${audioBasePath}button_tap.mp3`;

// urls
export const HOME_PAGE_URL = '/';
export const AJIO_WALLET_PAGE_URL = '/my-account/ajio-wallet';
export const MY_REWARDS_PAGE_URL = '/my-account/my-rewards';
export const PAYMENT_PROMOTION_POLICY_URL = `${parentUrl}/fee-payment-promotion-policy`;
export const AJIO_SALE_POLICY_URL = `${parentUrl}/ajio-own-sale-policy`;
export const VIEW_TC_NO_OFFER_URL = `${parentUrl}/fee-payment-promotion-policy`;
export const VIEW_TC_AJIO_CASH_URL = `${parentUrl}/fee-payment-promotion-policy`;
export const VIEW_TC_AJIO_POINTS_URL = `${parentUrl}/fee-payment-promotion-policy`;

// objects
export const WEB_SHARE_CONTENT = {
  title: 'I earned an exciting reward on AJIO! You can also play this fun game!',
  imageName: 'stw-ajio-trophy.jpg',
  imageUrl: `${imageBasePath}stw-ajio-trophy.jpg`,
  mimeType: 'image/jpeg'
};

export const NO_OFFER_MODAL_CONTENT = {
  headerContent: 'Oops, hard luck today',
  subHeaderContent: 'Better luck next time.',
  dartboardIcon: `${imageBasePath}stw-dartboard.svg`,
  termsUrl: `${parentUrl}/fee-payment-promotion-policy`,
  btnLabel: 'Continue Shopping',
  btnUrl: '/',
  closeIcon: MODAL_CIRCLE_CLOSE_ICON
};

export const OFFER_TYPES = {
  AJIO_CASH: 'AJIO_CASH',
  AJIO_POINTS: 'AJIO_POINTS',
  PROMO_COUPON: 'PROMO_COUPON',
  NO_OFFER: 'NO_OFFER'
};

export const GAME_ROUTES = {
  [SPIN_THE_WHEEL]: SPIN_THE_WHEEL,
  [SCRATCHCARD]: SCRATCHCARD
};

export const MY_REWARD_SCRATCH_API_ERROR_MESSAGES = [
  {
    errorCode: 400,
    icon: GIFT_ICON,
    errorMessage:
      'This game is not active now.<br />However do not miss out on our exciting offers',
    btnText: 'Continue Shopping',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'Game Not Found / Does not exist'
  },
  {
    errorCode: 454,
    icon: GIFT_ICON,
    errorMessage:
      'This game is not active now.<br />However do not miss out on our exciting offers',
    btnText: 'Continue Shopping',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'Game Not Found / Does not exist'
  },
  {
    errorCode: 500,
    icon: TIMER_ICON,
    errorMessage: 'Hey, we are experiencing heavy traffic, please try again after some time',
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'Internal Server Error'
  },
  {
    errorCode: 503,
    errorMessage: 'Oops! Something went wrong.<br />Please retry again.',
    icon: TIMER_ICON,
    btnText: 'Reload',
    btnActionType: 'RELOAD',
    errorType: 'Service Unavailable'
  },
  {
    errorCode: 504,
    errorMessage: 'Hey, we are experiencing heavy traffic, please try again after some time',
    icon: TIMER_ICON,
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'Gateway Timeout'
  },
  {
    errorCode: 16,
    icon: TIMER_ICON,
    errorMessage:
      'Hey, we are experiencing high traffic. Kindly check the rewards page in some time to view your winnings!',
    btnText: 'Okay',
    btnActionType: 'REFRESH_REWARD_LIST',
    errorType: 'REWARD_NOT_FOUND_ERROR'
  },
  {
    errorCode: 17,
    icon: TIMER_ICON,
    errorMessage: "Oops! You're late. Your scratch card has expired a moment ago.",
    btnText: 'Okay',
    btnActionType: 'CLOSE_MODAL',
    errorType: 'SCRATCH_CARD_EXPIRED_ERROR'
  }
];
